import React, { useState, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AdminHeader from './AdminHeader';
import AdminSidebar from './AdminSidebar';
import { useAuth } from '../../context/AuthContext';

const AdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { user, loading } = useAuth();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  useTranslation();

  useEffect(() => {
    if (loading) return;
    if (user && user.role === 'admin') {
      setIsAuthenticated(true);
    } else {
      setIsAuthenticated(false);
      navigate('/admin/login');
    }
  }, [user, loading, navigate]);

  if (loading || !isAuthenticated) {
    return null;
  }

  return (
    <div className="min-h-screen">
      {/* Sidebar */}
      <AdminSidebar
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        location={location}
        navigate={navigate}
      />

      {/* Main content */}
      <div className="lg:ml-[243px]">
        <AdminHeader
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
        />
        <main className="pt-4 pb-[70px] px-4 sm:px-5">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
